import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AmplifyModelService } from '../services/amplify-model-service.service';

@Injectable({
  providedIn: 'root'
})
export class TechnicianGuard implements CanActivate {
  private authService = inject(AmplifyModelService);
  private router = inject(Router);

  async canActivate(): Promise<boolean> {
    try {
      console.log('🛡️ TechnicianGuard - Checking technician access...');
      const groups = await this.authService.getUserGroups();
      console.log('👥 TechnicianGuard - User groups:', groups);
      
      if (groups.includes('Technicians') || groups.includes('ADMINS')) {
        console.log('✅ TechnicianGuard - Access granted (user is technician or admin)');
        return true;
      }
      
      console.log('❌ TechnicianGuard - Access denied (user is not technician or admin)');
      // Redirect to appropriate portal based on their actual groups
      const defaultRoute = this.getDefaultRouteForGroups(groups);
      console.log('🔄 TechnicianGuard - Redirecting to:', defaultRoute);
      this.router.navigate([defaultRoute]);
      return false;
    } catch (error) {
      console.log('🚫 TechnicianGuard - Authentication error, redirecting to login');
      console.error('TechnicianGuard error:', error);
      this.router.navigate(['/login']);
      return false;
    }
  }

  private getDefaultRouteForGroups(groups: string[]): string {
    if (groups.includes('SALES_REPS')) return '/dashboard';
    return '/dashboard';
  }
}